import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

import InlineMessages from '../../containers/inline-messages.jsx';

import {
    createProject, getIsShowingWithoutId,
    manualUpdateProject
} from '../../reducers/project-state';

import {
    filterInlineAlerts
} from '../../reducers/alerts';

import styles from './save-status.css';

// Wrapper for inline messages in the nav bar, which are all related to saving.
// Show any inline messages if present, else show the "Save Now" button if the
// project has changed.
// We decided to not use an inline message for "Save Now" because it is a reflection
// of the project state, rather than an event.
const SaveStatus = ({
    alertsList,
    projectChanged,
    onClickSave,
    createProject,
    isShowingWithoutId,
    isInTask
}) => (
    filterInlineAlerts(alertsList).length > 0 ? (
        <div style={{ marginLeft: 12 }}>
            <InlineMessages />
        </div>
    ) : projectChanged && (
        <div
            className={`${styles.saveNow} ${styles.saveButton}`}
            onClick={()=>{
                if (isInTask) {
                    window.teachEvent.emit('TASK_SAVE'); // 如果在课程中，则触发全局事件修改状态
                } else {
                    if (isShowingWithoutId) { //如果如果没有projectId，创建项目
                        createProject();
                    }else {
                        onClickSave();
                    }
                }
            }}
        >
            <FormattedMessage
                defaultMessage="Save Now"
                description="Title bar link for saving now"
                id="gui.menuBar.saveNowLink"
            />
        </div>
    ));

SaveStatus.propTypes = {
    alertsList: PropTypes.arrayOf(PropTypes.object),
    onClickSave: PropTypes.func,
    createProject: PropTypes.func,
    projectChanged: PropTypes.bool,
    isInTask: PropTypes.bool
};

const mapStateToProps = state => ({
    alertsList: state.scratchGui.alerts.alertsList,
    projectChanged: state.scratchGui.projectChanged,
    isShowingWithoutId: getIsShowingWithoutId(state.scratchGui.projectState.loadingState),
});

const mapDispatchToProps = dispatch => ({
    onClickSave: () => dispatch(manualUpdateProject()),
    createProject: () => dispatch(createProject()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SaveStatus);
